export default "__VITE_ASSET__CBBSe47u__"